export default "__VITE_ASSET__CL96hTUd__"